import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import client from 'data/client';
import useMe from 'data/hooks/useMe';
import Loader from 'components/Loaders/GlobalLoader';
import SimpleLoader from 'components/Loaders/SimpleLoader';
import { getToken } from 'utils/storage';

import Guest from './Guest';
import Main from './Main';

const Root = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { me, isLoading, isFetching } = useMe();
  const [showAnimation, setShowAnimation] = useState<boolean>(!getToken());
  const [showLoader, setShowLoader] = useState<boolean>(false);

  useEffect(() => {
    if (me === undefined && isFetching === false && showAnimation === false) {
      setShowAnimation(true);
    }
  }, [me, isFetching, showAnimation]);

  useEffect(() => {
    if (isLoading && !me) {
      setShowLoader(true);
      setTimeout(() => {
        setShowAnimation(false);
      }, 4000);
    } else if (!showAnimation) {
      setShowLoader(false);
    }
  }, [isLoading, me, setShowLoader, showAnimation, setShowAnimation]);

  useEffect(() => {
    client.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status >= 500) {
          enqueueSnackbar(`Temporarily unavailable, please try again later`, {
            variant: 'error',
          });
        }
        return Promise.reject(error);
      },
    );
  }, [enqueueSnackbar]);

  if (showLoader || isLoading) {
    return showAnimation ? <Loader /> : <SimpleLoader />;
  }

  if (!me) {
    return <Guest />;
  }

  return <Main />;
};

export default Root;
